import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class CardRowTableLoader extends Component {
    
    render() {
        const { avatar, hide_table_header, row_container_class } = this.props;
    
        return (
            <div className="ori-full-width ori-overflow-auto oriCardRowTableLoaderContainer">
                {
                    !hide_table_header &&
                    <TableRow avatar={false} />
                }
                {
                    [1,2,3,4,5,6,7,8,9].map((i)=>{
                        return(
                            <TableRow key={i} avatar={avatar} row_container_class={row_container_class} />
                        );
                    })
                }
            </div>
        );
    }
}

const TableRow = (props) => {
    return(
        <div className={`ori-full-width ori-flex-row ori-flex-jsb ori-tb-mrgn-5 ori-pad-5 ${props.row_container_class}`}>
            <div className="ori-pad-15">
                <div className="width4">
                    <p className={classNames("ori-card-loading",{"ori-height-xxl ori-width-xxl ori-border-radius-half": props.avatar,"ori-height-sm width1": !props.avatar})}>&nbsp;</p>
                </div>
            </div>
            {
                [1,2,3].map((i)=>{
                    return(
                        <div key={i} className="ori-pad-15 ori-flex-column ori-flex-jc">
                            <div className={`ori-card-loading ori-height-sm width${i}`}>&nbsp;</div>
                        </div>
                    );
                })
            }
        </div>
    );
}

TableRow.propTypes = {
    avatar: PropTypes.bool,
    row_container_class: PropTypes.string,
};

TableRow.defaultProps = {
    avatar: false,
    row_container_class: "ori-bg-white ori-box-shadow"
};

CardRowTableLoader.propTypes = {
    avatar: PropTypes.bool,
    hide_table_header: PropTypes.bool,
    row_container_class: PropTypes.string,
};

CardRowTableLoader.defaultProps = {
    avatar: false,
    hide_table_header: false,
};

export default CardRowTableLoader;


// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/loaders/cardrowtable/index.js